// extracted by mini-css-extract-plugin
export default {"community":"QaaQ7TfWVXdA6Pk_BXfy","articles":"Tte99_KCD2LptvDvZgvb"};